import { render } from "./noticeDetail.vue?vue&type=template&id=6de5b35d&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"

import "./noticeDetail.vue?vue&type=style&index=0&id=6de5b35d&lang=css"
import "./noticeDetail.vue?vue&type=style&index=1&id=6de5b35d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de5b35d"]])

export default __exports__